export default "__VITE_ASSET__vSY902tr__"